import React from 'react';

import { useAppDispatch } from 'src/hooks/useStore';
import { ActionButtonModal } from 'src/legacy/components/Modals';
import { useDeleteAppBuilderMutation } from 'src/services/api/appBuilderApi';
import { alertSnackbar } from 'src/store/ui/actions';

interface DeleteAppBuilderModalProps {
  appId: string;
  appName: string;
  onClose: () => void;
  onDeleted?: () => Promise<void> | void;
}

export const DeleteAppBuilderModal: React.FC<DeleteAppBuilderModalProps> = ({
  appId,
  appName,
  onClose,
  onDeleted,
}) => {
  const dispatch = useAppDispatch();
  const [deleteBuilder, { isLoading }] = useDeleteAppBuilderMutation();

  const handleConfirm = async () => {
    try {
      await deleteBuilder({ id: appId }).unwrap();
    } catch (error) {
      console.error(error);
      void dispatch(alertSnackbar({ errorMessage: 'Unable to delete app' }));
      return;
    }
    // The delete succeeded — any failure past this point (e.g. navigation
    // or cache cleanup) must not surface as "Unable to delete app".
    try {
      await onDeleted?.();
    } catch (error) {
      console.error(error);
    }
    onClose();
  };

  return (
    <ActionButtonModal
      open
      title={`Delete app "${appName}"?`}
      mainComponent={`This will permanently delete ${appName}. This action cannot be undone. You will not be able to recover your app once it has been deleted.`}
      positiveAction
      positiveActionText="Delete"
      cancelActionText="Cancel"
      onPositiveActionPerformed={() => void handleConfirm()}
      onClose={onClose}
      isLoading={isLoading}
    />
  );
};
